module.exports = __webpack_public_path__ + "img/pic_61.e8f7cb1d.jpg";